import { render } from "./DetalharCategoriaAvaliacao.vue?vue&type=template&id=a90705ba&scoped=true"
import script from "./DetalharCategoriaAvaliacao.vue?vue&type=script&lang=js"
export * from "./DetalharCategoriaAvaliacao.vue?vue&type=script&lang=js"

import "./DetalharCategoriaAvaliacao.vue?vue&type=style&index=0&id=a90705ba&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a90705ba"]])

export default __exports__